/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { useMemoSelector } from '@spa/redux/hooks'
import { isEqual } from 'lodash-es'
import type { FC, PropsWithChildren } from 'react'
import React, { memo } from 'react'
import { useDispatch } from 'react-redux'

import type { SelectedTarget } from '../../redux/reducers'
import { setSelectedTarget } from '../../redux/reducers'
import { getGridSelection, isSameSelectedDay } from '../../redux/selectors'

import { BaseTarget } from './BaseTarget'

type Props = PropsWithChildren<{
  targetType: SelectedTarget
  className?: string
}>

export const DayTarget: FC<Props> = memo(
  ({ targetType, className, children }) => {
    const dispatch = useDispatch()

    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    const { selected, copied, focused } = useMemoSelector(getGridSelection)
    const isContractSelected = selected?.data?.contractId
    const isSameDay = isSameSelectedDay({ selected, targetType })

    const isSelected =
      isSameDay &&
      !isContractSelected &&
      selected?.target === targetType?.target
    const isCopied = isEqual(copied?.data, targetType.data)

    return (
      <BaseTarget
        copied={isCopied}
        selected={isSelected}
        focused={focused}
        className={className}
        onClick={() => {
          dispatch(setSelectedTarget(targetType))
        }}
      >
        {children}
      </BaseTarget>
    )
  }
)
